import React, { useState, useEffect } from "react";
import {
  Form,
  DatePicker,
  Radio,
  Row,
  Col,
  Select,
  Input,
  Button,
  Table,
  message,
} from "antd";
import moment from "moment";
import { request } from "../../../utils/fetch";

const { RangePicker } = DatePicker;
const { Option } = Select;

const itemStyle = { width: "300px", marginRight: "15px" };
const labelStyleObj = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 },
};

const Labor = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `共 ${total} 条`,
  });
  useEffect(() => {
    getTableData();
  }, []);

  const handlerChange = (dates, dateStrings) => {
    if (dates === null) {
      form.setFieldsValue({
        rangeDate: null,
      });
    }
  };
  const radioChange = (e) => {
    const startDate = moment()
      .subtract(e.target.value - 1, "days")
      .format("YYYY-MM-DD");
    const endDate = moment().format("YYYY-MM-DD");
    form.setFieldsValue({
      rangeDate: [moment(startDate), moment(endDate)],
    });
  };
  // 重置
  const resetForm = () => {
    form.resetFields();
  };
  // 查询
  const submit = () => {
    // 查询时重置到第一页
    setPagination({
      ...pagination,
      current: 1,
    });
    getTableData({ pageNum: 1 });
  };
  const handleTableChange = (pagination) => {
    setPagination({
      ...pagination,
    });
    getTableData({
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    });
  };
  // 获取数据列表
  const getTableData = async (pageParams = {}) => {
    const { keyword, rangeDate, settlementAuditType } = form.getFieldsValue();
    setLoading(true);
    const params = {
      keyword,
      beginTime: rangeDate ? moment(rangeDate[0]).format("YYYY-MM-DD") : "",
      endTime: rangeDate ? moment(rangeDate[1]).format("YYYY-MM-DD") : "",
      settlementAuditType,
      pageNum: pageParams.pageNum || pagination.current,
      pageSize: pageParams.pageSize || pagination.pageSize,
    };
    try {
      const res = await request.get("/platform/labourAudit/list", params);
      setTableData(res.list);
      setPagination({
        ...pagination,
        total: res.totalCount,
        current: pageParams.pageNum || pagination.current,
        pageSize: pageParams.pageSize || pagination.pageSize,
      });
    } catch (error) {
      message.error(error);
    } finally {
      setLoading(false);
    }
  };
  const goDetail = (record) => {
    // 跳转到详情页
    props.history.push({ pathname: `/admin/labor/detail/${record.auditNo}` });
  };
  // 导出
  const exportExcel = async () => {
    try {
      const { keyword, rangeDate, settlementAuditType } = form.getFieldsValue();
      const params = {
        keyword,
        beginTime: rangeDate ? moment(rangeDate[0]).format("YYYY-MM-DD") : "",
        endTime: rangeDate ? moment(rangeDate[1]).format("YYYY-MM-DD") : "",
        settlementAuditType,
      };
      request.downloadTemplate("/platform/labourAudit/exportDetail", params);
    } catch (error) {
      message.error(error);
    }
  };
  // 列表字段
  const tableColumns = [
    {
      title: "创建时间",
      dataIndex: "createTime",
      key: "createTime",
      width: 180,
      align: "center",
      render: (row) => {
        return row ? moment(row).format("YYYY-MM-DD HH:mm:ss") : "";
      },
    },
    {
      title: "项目",
      dataIndex: "projectName",
      key: "projectName",
      align: "center",
    },
    {
      title: "城市",
      dataIndex: "cityName",
      key: "cityName",
      align: "center",
    },
    {
      title: "劳务简称",
      dataIndex: "labourName",
      key: "labourName",
      align: "center",
    },
    {
      title: "结算类型",
      dataIndex: "typeName",
      key: "typeName",
      align: "center",
    },
    {
      title: "日期段",
      align: "center",
      render: (row) => {
        return row ? row.beginDate + "~" + row.endDate : "";
      },
    },
    {
      title: "结算费用",
      dataIndex: "totalAmount",
      key: "totalAmount",
      align: "center",
    },
    {
      title: "结算人数",
      dataIndex: "riderCount",
      key: "riderCount",
      align: "center",
    },
    {
      title: "操作",
      dataIndex: "operation",
      key: "operation",
      align: "center",
      render: (_, record) => (
        <Button type="link" onClick={() => goDetail(record)}>
          查看
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Form form={form} {...labelStyleObj} labelAlign="left">
        <Row>
          <Form.Item label="时间" name="rangeDate">
            <RangePicker
              allowClear
              format={"YYYY-MM-DD"}
              onChange={handlerChange}
            />
          </Form.Item>
          <Form.Item style={{ width: "600px", marginLeft: "15px" }}>
            <Radio.Group onChange={radioChange}>
              <Radio value={1}>今天</Radio>
              <Radio value={7}>近7天</Radio>
              <Radio value={30}>近30天</Radio>
            </Radio.Group>
          </Form.Item>
        </Row>
        <Row>
          <Form.Item
            style={itemStyle}
            name="settlementAuditType"
            label="结算类型"
          >
            <Select placeholder="全部" allowClear>
              <Option value="1">考核结算</Option>
              <Option value="2">对赌结算</Option>
            </Select>
          </Form.Item>
          <Form.Item style={itemStyle} name="keyword" label="关键字">
            <Input placeholder="城市 | 劳务简称" />
          </Form.Item>
        </Row>
        <Row>
          <Col span={24} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              onClick={submit}
              style={{ marginRight: "15px" }}
            >
              查询
            </Button>
            <Button onClick={resetForm}>重置</Button>
            <Button
              type="primary"
              style={{ marginLeft: "15px" }}
              onClick={exportExcel}
            >
              导出
            </Button>
          </Col>
        </Row>
      </Form>
      <Table
        columns={tableColumns}
        dataSource={tableData}
        pagination={pagination}
        onChange={handleTableChange}
        bordered
        size="middle"
        loading={loading}
        rowKey={(record) => record.id}
      />
    </div>
  );
};
export default Labor;
